import React, { Component } from 'react';
import moment from 'moment';

import CheckingParkingModel from './CheckingParkingModel';
import CheckingParkingTable from './CheckingParkingTable';

import { Table, Row, Col, Badge, Modal, message } from 'antd';

class MkaDetectionsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    statusDetail: {
      showed: false,
      data: null
    },
    zoneDetectionDetail: {
      showed: false,
      data: null
    }
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  onClickImg(base64data) {
    var newTab = window.open('', '_blank', "menubar=no,status=no,titlebar=no,location=no,toolbar=no,scrollbars=yes,resizable=yes,top=50,left=500,width=800,height=600");
    newTab.document.body.innerHTML = '<img src="' + base64data + '">';
  }

  expandedRowRender(record) {
    let img1 = "data:image/jpeg;base64," + record.image;
    return (
      <Row>
        <Col span={16}>
          <img src={img1} onClick={() => { this.onClickImg(img1) }} width={250} />
        </Col>
      </Row>
    );
  }

  onShowStatusDetail(record) {
    let statusDetail = this.state.statusDetail;
    statusDetail.showed = true;
    this.setState({
      statusDetail
    });

    statusDetail.parkinglocation = record.parkingLocationId;
    statusDetail.licenceplate = record.plate.slice(-4);
    statusDetail.timestamp = record.timestamp;
    statusDetail.plate = record.plate;

    CheckingParkingModel.getAll(
      statusDetail.parkinglocation,
      statusDetail.licenceplate,
      statusDetail.timestamp)
      .then(data => {
        statusDetail.data = data
        this.setState({
          statusDetail
        });
      })
      .catch(err => {
        message.warning('Pakovací oprávnění se nepodařilo načíst!');
        statusDetail.data = [];
        this.setState({
          statusDetail
        });
      });
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
    }, {
      title: 'Reg. značka',
      dataIndex: 'plate',
      key: 'plate',
    }, {
      title: 'Čas detekce',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (text, record) => (
        <span>{text ? moment(text).format('LLLL') : null}</span>
      ),
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        return (a.timestamp < b.timestamp) ? -1 : ((a.timestamp > b.timestamp) ? 1 : 0);
      }
    }, {
      title: 'Zrušeno',
      dataIndex: 'cancelled',
      key: 'cancelled',
      filters: [
        { text: 'Ano', value: 'true' },
        { text: 'Ne', value: 'false' },        
      ],
      render: (text, record) => {
        if (record.cancelled) {
          return (
            <Badge status="warning" text="Ano" />
          )
        } else {
          return (
            <Badge status="success" text="Ne" />
          )
        }
      },      
      onFilter: (value, record) => {         
        return (record.cancelled.toString() == value.toString()) ? true : false 
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          onChange={this.handleChange} />
        <Modal
          width={920}
          title={this.state.statusDetail.plate
            ? 'Parkovací opravnění pro RZ '
            + this.state.statusDetail.plate
            + ' : '
            + this.state.statusDetail.licenceplate
            : 'Parkovací opravnění pro RZ '}
          visible={this.state.statusDetail.showed}
          onCancel={() => {
            let statusDetail = {
              showed: false,
              data: null
            };
            this.setState({ statusDetail });
          }}
          footer={<p></p>} >
          <CheckingParkingTable
            data={!this.state.statusDetail.data ? [] : this.state.statusDetail.data}
            loading={!this.state.statusDetail.data ? true : false}
            rowKey="plate"
          />
        </Modal>
        <Modal
          width={920}
          title="Přehledové snímky"
          visible={this.state.zoneDetectionDetail.showed}
          onCancel={() => {
            let zoneDetectionDetail = {
              showed: false,
              data: null
            };
            this.setState({ zoneDetectionDetail });
          }}
          footer={<p></p>} >
        </Modal>
      </div>
    );
  }
}

export default MkaDetectionsTable;


// WEBPACK FOOTER //
// ./src/components/MkaDetectionsTable.js